import { memo } from "react";
import Image from "next/image";
import Link from "next/link";

import styles from "@styles/dropAuction/dropAuction.module.scss";

const DropLandingBrand = () => {
  return (
    <div className={styles.dropLandingBrand}>
      {/* <div className={styles.dropLandingImg}>
				<Image
					width='350px'
					height='180px'
					src='https://betterthat-dev.s3.ap-southeast-2.amazonaws.com//assets/BT-drop-black.webp'
					alt='BT-drop-black'
				/>
			</div> */}
      <div className={styles.landBrandBox}>
        <div className={styles.landBrandBoxLt}>
          <div className={styles.landBrandBoxInner}>
            <h2>Fishing in Godzone Drop</h2>
            <h6>A brand new way to shop</h6>
            <p>
              Pick awesome products in your size and favourite colour and hang
              on while the price drops. When the price is right, hit buy before
              someone else beats you to it.
            </p>
            <span className={styles.auctionsLink}>
              <Link href={`/drop-auctions/all`}>
                <a>Click here to check out upcoming Drop Auctions</a>
              </Link>
            </span>
            <div className={styles.moneyIcon}>
              <i>
                <Image
                  layout="fill"
                  src={"/assets/images/dollar-icon.png"}
                  alt={"box"}
                />
              </i>
            </div>
          </div>
        </div>
        <div className={styles.landBrandBoxRt}>
          <iframe
            src="https://fast.wistia.net/embed/iframe/b3emre0ys5?videoFoam=true"
            title="Drop Auction"
            allow="autoplay; fullscreen"
            allowtransparency="true"
            frameBorder="0"
            scrolling="no"
            name="wistia_embed"
            allowFullScreen="allowfullscreen"
            msallowfullscreen="msallowfullscreen"
            width="100%"
            height="100%"
            className="wistia_embed"
            mozallowfullscreen="mozallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen"
            oallowfullscreen="oallowfullscreen"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default memo(DropLandingBrand);
